<template>
    <nav class="blmk-nav">
        <router-link
            :to="{ path: typePath('/posts', '/posts/type'), query: params }"
            class="blmk-tab"
            :class="{ 'is-active': isListActive }"
        >
            <iconList class="blmk-icon" />
            <span class="blmk-label">{{ $t('post.page.choiceviewlistposts.listview') }}</span>
        </router-link>

        <router-link
            :to="{ path: typePath('/kanban', '/kanban/type'), query: params }"
            class="blmk-tab"
            :class="{ 'is-active': currentPath.startsWith('/kanban') }"
        >
            <iconKanban class="blmk-icon" />
            <span class="blmk-label">{{ $t('post.page.choiceviewlistposts.kanbanview') }}</span>
        </router-link>

        <router-link
            :to="{ path: typePath('/map', '/map/type'), query: params }"
            class="blmk-tab"
            :class="{ 'is-active': currentPath.startsWith('/map') }"
        >
            <iconGlobe class="blmk-icon" />
            <span class="blmk-label">{{ $t('post.page.choiceviewlistposts.cardview') }}</span>
        </router-link>

        <router-link
            :to="{ path: typePath('/statistiques', '/statistiques/type'), query: params }"
            class="blmk-tab"
            :class="{ 'is-active': currentPath.startsWith('/statistiques') }"
        >
            <iconChart class="blmk-icon" />
            <span class="blmk-label">{{ $t('post.page.choiceviewlistposts.statisticsview') }}</span>
        </router-link>

        <router-link
            :to="{ path: typePath('/performances', '/performances/type'), query: params }"
            class="blmk-tab"
            :class="{ 'is-active': currentPath.startsWith('/performances') }"
        >
            <iconProgress class="blmk-icon" />
            <span class="blmk-label">{{ $t('post.page.choiceviewlistposts.performanceview') }}</span>
        </router-link>
    </nav>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import iconList from '@/components/icons/iconList'
import iconKanban from '@/components/icons/iconKanban'
import iconGlobe from '@/components/icons/iconGlobe'
import iconChart from '@/components/icons/iconChart'
import iconProgress from '@/components/icons/iconProgress'

export default {
    name: 'ButtonListMapKanban',
    components: {
        iconList,
        iconKanban,
        iconGlobe,
        iconChart,
        iconProgress
    },
    computed: {
        params() {
            return this.$route.query ? this.$route.query : {}
        },
        currentPath() {
            return this.$route.path
        },
        formTypeId() {
            return this.$route.params.form_type_id || null
        },
        isListActive() {
            return this.currentPath === '/posts' || this.currentPath.startsWith('/posts/type/')
        }
    },
    methods: {
        typePath(base, typeBase) {
            return this.formTypeId ? `${typeBase}/${this.formTypeId}` : base
        }
    }
}
</script>

<style>
.blmk-nav {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: #f1f5f9;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 4px;
}

.blmk-tab {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 12px;
    border-radius: 8px;
    font-size: 0.78rem;
    font-weight: 500;
    color: #64748b;
    text-decoration: none;
    transition: all 0.15s ease;
    white-space: nowrap;
}

.blmk-tab:hover {
    color: #0891B2;
    background: rgba(8, 145, 178, 0.06);
    text-decoration: none;
}

.blmk-tab.is-active {
    background: #fff;
    color: #0891B2;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.blmk-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
}

.blmk-tab .blmk-icon {
    color: #94a3b8;
}

.blmk-tab:hover .blmk-icon,
.blmk-tab.is-active .blmk-icon {
    color: #0891B2;
}

@media (max-width: 1200px) {
    .blmk-label {
        display: none;
    }
    .blmk-tab {
        padding: 6px 10px;
    }
}
</style>
